import { ChevronRight, Home } from 'lucide-react'
import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

export interface BreadcrumbItem {
  label: string
  href?: string
}

export function Breadcrumb({
  items,
  className,
  variant = 'light',
}: {
  items: BreadcrumbItem[]
  className?: string
  variant?: 'light' | 'dark'
}) {
  const isDark = variant === 'dark'

  return (
    <nav aria-label="Breadcrumb" className={cn('flex flex-wrap items-center gap-1.5 text-sm', className)}>
      <Link
        to="/"
        aria-label="Home"
        className={cn(
          'inline-flex shrink-0 transition-colors',
          isDark
            ? 'text-white/50 hover:text-white/85'
            : 'text-primary-400 hover:text-primary-600',
        )}
      >
        <Home className="h-4 w-4" strokeWidth={1.75} />
      </Link>

      {items.map((item, i) => (
          <span key={`${item.label}-${i}`} className="inline-flex items-center gap-1.5">
            <ChevronRight
              className={cn(
                'h-3.5 w-3.5 shrink-0',
                isDark ? 'text-white/25' : 'text-primary-200',
              )}
              strokeWidth={2}
              aria-hidden
            />
            {item.href ? (
              <Link
                to={item.href}
                className={cn(
                  'font-medium tracking-wide transition-colors',
                  isDark
                    ? 'text-white/60 hover:text-white'
                    : 'text-primary-500 hover:text-primary-700',
                )}
              >
                {item.label}
              </Link>
            ) : (
              <span
                aria-current="page"
                className={cn(
                  'font-semibold tracking-wide',
                  isDark ? 'text-white' : 'text-qbc-navy',
                )}
              >
                {item.label}
              </span>
            )}
          </span>
        ))}
    </nav>
  )
}
